var font = {
    "0": "M98 -81v961l184 185h333l185 -185v-961l-185 -185h-333zM305 -58h287v915h-287v-915z",
    "1": "M99 -58h99v806h-99v74l191 243h116v-1123h100v-208h-407v208z",
    "2": "M100 -266v584l185 185h310v354h-288v-109h-207v132l185 185h333l185 -185v-400l-185 -184h-311v-354h288v109h208v-317h-703z",
    "3": "M98 51h207v-109h287v354h-215v207h215v354h-287v-109h-207v132l184 185h333l185 -185v-352l-129 -129l129 -129v-351l-185 -185h-333l-184 185v132z",
    "4": "M46 89v252l447 724h251v-769h100v-207h-100v-147h100v-208h-407v208h99v147h-490zM261 296h275v447z",
    "5": "M103 51h207v-109h288v354h-311l-184 184v585h702v-208h-495v-354h310l185 -185v-399l-185 -185h-333l-184 185v132z",
    "6": "M98 -81v961l184 185h333l185 -185v-132h-208v109h-287v-354h310l185 -185v-399l-185 -185h-333zM305 -58h287v354h-287v-354z",
    "7": "M90 748v317h704v-221l-245 -902h96v-208h-406v208h95l248 915h-284v-109h-208z",
    "8": "M98 -81v351l128 129l-128 129v352l184 185h333l185 -185v-352l-129 -129l129 -129v-351l-185 -185h-333zM305 -58h287v354h-287v-354zM305 503h287v354h-287v-354z",
    "9": "M98 51h207v-109h287v354h-310l-184 184v400l184 185h333l185 -185v-961l-185 -185h-333l-184 185v132zM305 503h287v354h-287v-354z",
    "A": "M64 -266l182 1331h385l181 -1331h-229l-23 258h-243l-24 -258h-229zM333 172h210l-64 713h-83z",
    "B": "M103 -266v1331h485l180 -180v-395l-89 -91l89 -90v-395l-180 -180h-485zM333 -86h205v396h-205v-396zM333 490h205v395h-205v-395z",
    "C": "M98 -86v971l179 180h306l180 -180v-278h-229v278h-206v-971h206v339h229v-339l-180 -180h-306z",
    "D": "M103 -266v1331h485l180 -180v-971l-180 -180h-485zM333 -86h205v971h-205v-971z",
    "E": "M103 -266v1331h551v-180h-321v-354h205v-179h-205v-438h321v-180h-551z",
    "F": "M103 -266v1331h551v-180h-321v-354h205v-179h-205v-618h-230z",
    "G": "M98 -86v971l179 180h306l180 -180v-278h-231v278h-204v-971h204v306h-102v179h333v-485l-180 -180h-306z",
    "H": "M103 -266v1331h230v-576h206v576h229v-1331h-229v575h-206v-575h-230z",
    "I": "M103 -266v1331h230v-1331h-230z",
    "J": "M61 -86v339h229v-339h208v1151h229v-1151l-180 -180h-306z",
    "K": "M103 -266v1331h230v-576h51l237 576h231l-275 -666l275 -665h-231l-237 575h-51v-575h-230z",
    "L": "M103 -266v1331h230v-1151h321v-180h-551z",
    "M": "M103 -266v1331h293l116 -534h75l117 534h294v-1331h-230v755h-56l-141 -541h-41l-143 541h-54v-755h-230z",
    "N": "M103 -266v1331h229l189 -576h17v576h230v-1331h-230l-188 575h-18v-575h-229z",
    "O": "M98 -86v971l179 180h306l180 -180v-971l-180 -180h-306zM326 -86h206v971h-206v-971z",
    "P": "M103 -266v1331h485l180 -180v-486l-180 -179h-256v-486h-229zM332 399h206v486h-206v-486z",
    "Q": "M98 -86v971l179 180h306l180 -180v-971l-90 -90h90v-90h-486zM328 -86h206v971h-206v-971z",
    "R": "M103 -266v1331h485l180 -180v-343l-142 -143l142 -142v-523h-229v575h-206v-575h-230zM333 490h206v395h-206v-395z",
    "S": "M98 -86v259h230v-259h206v395h-257l-179 180v396l179 180h306l180 -180v-259h-229v259h-206v-396h255l180 -180v-395l-180 -180h-306z",
    "T": "M88 885v180h665v-180h-218v-1151h-229v1151h-218z",
    "U": "M103 -86v1151h229v-1151h206v1151h230v-1151l-180 -180h-306z",
    "V": "M83 1065h230l102 -1151h84l103 1151h230l-183 -1331h-384z",
    "W": "M79 1065h230l110 -713h47l79 713h66l79 -713h46l112 713h229l-229 -1331h-147l-82 438h-83l-82 -438h-145z",
    "X": "M90 -266l219 665l-219 666h231l102 -316l104 316h229l-218 -666l218 -665h-229l-104 315l-102 -315h-231z",
    "Y": "M68 1065h229l103 -513h84l103 513h230l-261 -756v-575h-228v575z",
    "Z": "M103 -86l418 971h-418v180h526l139 -180l-418 -971h418v-180h-526z"
};
var font_size = 23,
    panel_Hor_Adjustment = 0,
    font_Top_Adjustment = -16,
    tracking = 2,
    middleSplitAdjustment = -0.5,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -195,
        horizontal: 0,
        scale_width: 0,
        scale_height: 0,
    },
    colors = {
        characters: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                '#006072', // teal
            ]
        },
        numbers: {
            home: [
                "#FFFFFF", // white
                "#0a0203", // black
            ],
            away: [
                '#0a0203', // teal
                "#006072", // black
            ]
        }
    },
    outlines = {
        characters: {
            width: 1.7
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 0.5, // this moves it up from the bottom
            horizontal: 1,
            scale_width: 15.5,
            scale_height: 15.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 15,
        left: -5,
        width: 105,
        height: 80,
        middle_Space: 6,
        oneOffset: 6
    };
